import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import mitt from 'mitt'
import axios from 'axios'

// 导入组件库
import Components from './components'

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css'

// 创建事件总线
const eventBus = mitt()

// 添加axios响应拦截器
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 444) {
      // 清除本地存储中的用户信息
      localStorage.removeItem('user');
      console.log('清除过期的用户认证信息');
      
    }
    return Promise.reject(error);
  }
);

const app = createApp(App)
  .use(store)
  .use(router)
  .use(Components) // 注册全局组件

// 将事件总线添加到应用全局属性中
app.config.globalProperties.eventBus = eventBus

// 也添加到app.provide中，使用依赖注入方式访问
app.provide('eventBus', eventBus)

// 应用根实例将用于组件中通过 this.$root 访问
const appRoot = app.mount('#app')

// 添加事件总线到根实例
appRoot.eventBus = eventBus

// Apply initial theme from store
const initialTheme = store.getters.currentTheme
document.body.setAttribute('data-theme', initialTheme)
